// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.renderer img, .renderer video {
    height: auto;
    max-width: 50%;
}

.renderer img:hover {
    cursor: pointer;
}

.renderer table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 24px 8px 0px 0px;
    border: 1px solid var(--ds-background-accent-gray-subtler, #C1C7D0);
}

.renderer tbody {
    border-bottom: none;
}

.renderer th {
    background-color: var(--ds-background-neutral, #F4F5F7);
    text-align: left;
    border-width: 1px 0px 0px 1px;
    border-style: solid;
    border-color: var(--ds-background-accent-gray-subtler, #C1C7D0);
    padding: 8px;
}

.renderer td {
    border-width: 1px 0px 0px 1px;
    border-style: solid;
    border-color: var(--ds-background-accent-gray-subtler, #C1C7D0);
    padding: 8px;
}

.renderer blockquote {
    color: inherit;
    padding-left: 0.8rem;
    font-style: italic;
    border-left: 2px solid var(--ds-border, #DFE1E6);
}

.renderer pre {
    font-size: 12px;
    font-weight: normal;
    display: inline-block;
    padding: 8px;
    background-color: rgba(9, 30, 66, 0.08);
    border-radius: 6px;
    border-style: none;
    white-space: pre-wrap;
    margin: 0 4px 0 4px;
}

.renderer tt {
    --ds--code--bg-color: var(--ds-background-neutral, rgba(9, 30, 66, 0.08));
    color: var(--ds-text, #172B4D);
    white-space: nowrap;
    background: var(--ds--code--bg-color, var(--ds-background-neutral, #F4F5F7));
    border-radius: 3px;
    padding: 2px 4px;
}

.renderer .panel {
    padding: 8px;
    border-radius: 6px;
}

.pointer-on-hover:hover {
    cursor: pointer;
}

div[style*="background-color: #deebff"] {
    background: var(--ds-background-accent-blue-subtlest, #DEEBFF) !important;
}

div[style*="background-color: #fffae6"] {
    background-color: var(--ds-background-accent-yellow-subtlest, #FFFAE6) !important;
}

div[style*="background-color: #e3fcef"] {
    background-color: var(--ds-background-accent-green-subtlest, #E3FCEF) !important;
}

div[style*="background-color: #ffebe6"] {
    background-color: var(--ds-background-accent-red-subtlest, #FFEBE6) !important;
}

div[style*="background-color: #eae6ff"] {
    background-color: var(--ds-background-accent-purple-subtlest, #EAE6FF) !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/Description.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,mEAAmE;AACvE;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uDAAuD;IACvD,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,+DAA+D;IAC/D,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,+DAA+D;IAC/D,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,yEAAyE;IACzE,8BAA8B;IAC9B,mBAAmB;IACnB,4EAA4E;IAC5E,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yEAAyE;AAC7E;;AAEA;IACI,iFAAiF;AACrF;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,8EAA8E;AAClF;;AAEA;IACI,iFAAiF;AACrF","sourcesContent":[".renderer img, .renderer video {\n    height: auto;\n    max-width: 50%;\n}\n\n.renderer img:hover {\n    cursor: pointer;\n}\n\n.renderer table {\n    border-collapse: collapse;\n    table-layout: fixed;\n    width: 100%;\n    margin: 24px 8px 0px 0px;\n    border: 1px solid var(--ds-background-accent-gray-subtler, #C1C7D0);\n}\n\n.renderer tbody {\n    border-bottom: none;\n}\n\n.renderer th {\n    background-color: var(--ds-background-neutral, #F4F5F7);\n    text-align: left;\n    border-width: 1px 0px 0px 1px;\n    border-style: solid;\n    border-color: var(--ds-background-accent-gray-subtler, #C1C7D0);\n    padding: 8px;\n}\n\n.renderer td {\n    border-width: 1px 0px 0px 1px;\n    border-style: solid;\n    border-color: var(--ds-background-accent-gray-subtler, #C1C7D0);\n    padding: 8px;\n}\n\n.renderer blockquote {\n    color: inherit;\n    padding-left: 0.8rem;\n    font-style: italic;\n    border-left: 2px solid var(--ds-border, #DFE1E6);\n}\n\n.renderer pre {\n    font-size: 12px;\n    font-weight: normal;\n    display: inline-block;\n    padding: 8px;\n    background-color: rgba(9, 30, 66, 0.08);\n    border-radius: 6px;\n    border-style: none;\n    white-space: pre-wrap;\n    margin: 0 4px 0 4px;\n}\n\n.renderer tt {\n    --ds--code--bg-color: var(--ds-background-neutral, rgba(9, 30, 66, 0.08));\n    color: var(--ds-text, #172B4D);\n    white-space: nowrap;\n    background: var(--ds--code--bg-color, var(--ds-background-neutral, #F4F5F7));\n    border-radius: 3px;\n    padding: 2px 4px;\n}\n\n.renderer .panel {\n    padding: 8px;\n    border-radius: 6px;\n}\n\n.pointer-on-hover:hover {\n    cursor: pointer;\n}\n\ndiv[style*=\"background-color: #deebff\"] {\n    background: var(--ds-background-accent-blue-subtlest, #DEEBFF) !important;\n}\n\ndiv[style*=\"background-color: #fffae6\"] {\n    background-color: var(--ds-background-accent-yellow-subtlest, #FFFAE6) !important;\n}\n\ndiv[style*=\"background-color: #e3fcef\"] {\n    background-color: var(--ds-background-accent-green-subtlest, #E3FCEF) !important;\n}\n\ndiv[style*=\"background-color: #ffebe6\"] {\n    background-color: var(--ds-background-accent-red-subtlest, #FFEBE6) !important;\n}\n\ndiv[style*=\"background-color: #eae6ff\"] {\n    background-color: var(--ds-background-accent-purple-subtlest, #EAE6FF) !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
